import { useState, useEffect } from 'react';

const useOrientation = () => {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia('(orientation: portrait)').matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia?.('(orientation: portrait)');

    const handleChange = evt => setIsPortrait(evt.matches);

    mediaQuery?.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return { isPortrait, isLandscape: !isPortrait };
};

export default useOrientation;
